export default __webpack_public_path__ + "static/media/con_frEND01.be1c47c0.jpg";